import { Input, Button, Form } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { addNutShape, modifyNutShape } from "./NutShapeSlice";
import { CommonContext, CommonContextType } from "../../contexts/CommonContext";

export default function AddNutShape(): JSX.Element {
  const dispatch = useDispatch();
  const { setModelChange, messageApi, editBodySize, setEditBodySize } =
    React.useContext(CommonContext) as CommonContextType;
  const [form] = Form.useForm();
  React.useEffect(() => {
    if (editBodySize?.id) {
      form.setFieldsValue(editBodySize);
    }
    else{
      form.resetFields();
    }
  }, [editBodySize, form]);

  const onFinish = (values: any) => {
    if (editBodySize?.id) {
      values.updated_datetime = new Date().toLocaleString() + "";
      dispatch(modifyNutShape(values, editBodySize?.id));
      /* messageApi.open({
        type: "success",
        content: "Nut Shape Updated successfully",
      }); */
    } else {
      values.created_datetime = new Date().toLocaleString() + "";
      dispatch(addNutShape(values));
    }
    setModelChange(false);
    setEditBodySize(null);
    form.resetFields();
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <Form
      form={form}
      layout={"vertical"}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="Nut Shape"
        name="shape_name"
        rules={[
          {
            required: true,
            message: "Please enter shape name",
          }
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Nut Shape Code"
        name="shape_code"
        rules={[
          {
            required: true,
            message: "Please enter shape name code",
          }
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item>
                <Button style={{ backgroundColor: '#018B98', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} type="primary" htmlType="submit" >{editBodySize?.id ? 'Update' : 'Create'}</Button>
            </Form.Item>
    </Form>
  );
}
